import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Btn from '../../../components/Btn';
import '../../../grid.css';
import './cash.css';

class CASH extends Component {
    toggleCASHIsVisible() {
        const { setCashIsVisible, isVisible } = this.props;
        setCashIsVisible(!isVisible);
    }

    toggleIncludeCash() {
        const { setIncludeCash, includeCash } = this.props;
        setIncludeCash(!includeCash);
    }

    render() {
        const {
            isVisible, isLocked, includeCash,
        } = this.props;

        return (
            <div>
                <Btn label="Cash" onClick={(e, value) => this.toggleCASHIsVisible(value)} />
                {isVisible ? (
                    <div className="row">
                        <div className="col span-1-of-2 checkboxes">
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        disabled={isLocked}
                                        onChange={() => this.toggleIncludeCash()}
                                        checked={includeCash}
                                    />
                                }
                                label="Include Cash Purchse in Simulation"
                            />
                        </div>
                    </div>
                ) : null}
            </div>
        );
    }
}

CASH.propTypes = {
    isVisible: PropTypes.bool.isRequired,
    isLocked: PropTypes.bool.isRequired,
    includeCash: PropTypes.bool.isRequired,
    setIncludeCash: PropTypes.func.isRequired,
    setCashIsVisible: PropTypes.func.isRequired,
};

CASH.defaultProps = {};

export default CASH;



// WEBPACK FOOTER //
// ./src/containers/Inputs/CASH/CASH.js